module.exports = __webpack_public_path__ + "src/app/_content/imgs/discover/mot/Motorrad-connectivity.jpg?d25e1a82a24078f21979454276de1363";